import { b as qr, c as or, d as mr, e as yr, f as dr, g as lr, h as Pr } from "./_baseIsEqual-DrdyeFFU.js";
import { r as br } from "./isObject-D_3-es0R.js";
import { b as v, r as Ir } from "./toString-Cs_Mc-g1.js";
import { r as hr } from "./isSymbol-CMDcKCTp.js";
import { r as gr } from "./identity-s5chnOHj.js";
var y, U;
function Rr() {
  if (U) return y;
  U = 1;
  var a = qr(), n = or(), e = 1, t = 2;
  function i(r, u, s, f) {
    var h = s.length, _ = h, c = !f;
    if (r == null)
      return !_;
    for (r = Object(r); h--; ) {
      var o = s[h];
      if (c && o[2] ? o[1] !== r[o[0]] : !(o[0] in r))
        return !1;
    }
    for (; ++h < _; ) {
      o = s[h];
      var p = o[0], m = r[p], H = o[1];
      if (c && o[2]) {
        if (m === void 0 && !(p in r))
          return !1;
      } else {
        var F = new a();
        if (f)
          var N = f(m, H, p, r, u, F);
        if (!(N === void 0 ? n(H, m, e | t, f, F) : N))
          return !1;
      }
    }
    return !0;
  }
  return y = i, y;
}
var d, $;
function cr() {
  if ($) return d;
  $ = 1;
  var a = br();
  function n(e) {
    return e === e && !a(e);
  }
  return d = n, d;
}
var l, X;
function Mr() {
  if (X) return l;
  X = 1;
  var a = cr(), n = mr();
  function e(t) {
    for (var i = n(t), r = i.length; r--; ) {
      var u = i[r], s = t[u];
      i[r] = [u, s, a(s)];
    }
    return i;
  }
  return l = e, l;
}
var P, Z;
function _r() {
  if (Z) return P;
  Z = 1;
  function a(n, e) {
    return function(t) {
      return t == null ? !1 : t[n] === e && (e !== void 0 || n in Object(t));
    };
  }
  return P = a, P;
}
var b, B;
function Cr() {
  if (B) return b;
  B = 1;
  var a = Rr(), n = Mr(), e = _r();
  function t(i) {
    var r = n(i);
    return r.length == 1 && r[0][2] ? e(r[0][0], r[0][1]) : function(u) {
      return u === i || a(u, i, r);
    };
  }
  return b = t, b;
}
var I, J;
function x() {
  if (J) return I;
  J = 1;
  var a = v(), n = hr(), e = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, t = /^\w*$/;
  function i(r, u) {
    if (a(r))
      return !1;
    var s = typeof r;
    return s == "number" || s == "symbol" || s == "boolean" || r == null || n(r) ? !0 : t.test(r) || !e.test(r) || u != null && r in Object(u);
  }
  return I = i, I;
}
var g, Q;
function Ar() {
  if (Q) return g;
  Q = 1;
  var a = yr(), n = "Expected a function";
  function e(t, i) {
    if (typeof t != "function" || i != null && typeof i != "function")
      throw new TypeError(n);
    var r = function() {
      var u = arguments, s = i ? i.apply(this, u) : u[0], f = r.cache;
      if (f.has(s))
        return f.get(s);
      var h = t.apply(this, u);
      return r.cache = f.set(s, h) || f, h;
    };
    return r.cache = new (e.Cache || a)(), r;
  }
  return e.Cache = a, g = e, g;
}
var R, W;
function Sr() {
  if (W) return R;
  W = 1;
  var a = Ar(), n = 500;
  function e(t) {
    var i = a(t, function(u) {
      return r.size === n && r.clear(), u;
    }), r = i.cache;
    return i;
  }
  return R = e, R;
}
var M, Y;
function Er() {
  if (Y) return M;
  Y = 1;
  var a = Sr(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, e = /\\(\\)?/g, t = a(function(i) {
    var r = [];
    return i.charCodeAt(0) === 46 && r.push(""), i.replace(n, function(u, s, f, h) {
      r.push(f ? h.replace(e, "$1") : s || u);
    }), r;
  });
  return M = t, M;
}
var C, k;
function pr() {
  if (k) return C;
  k = 1;
  var a = v(), n = x(), e = Er(), t = Ir();
  function i(r, u) {
    return a(r) ? r : n(r, u) ? [r] : e(t(r));
  }
  return C = i, C;
}
var A, V;
function q() {
  if (V) return A;
  V = 1;
  var a = hr();
  function n(e) {
    if (typeof e == "string" || a(e))
      return e;
    var t = e + "";
    return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
  }
  return A = n, A;
}
var S, j;
function vr() {
  if (j) return S;
  j = 1;
  var a = pr(), n = q();
  function e(t, i) {
    i = a(i, t);
    for (var r = 0, u = i.length; t != null && r < u; )
      t = t[n(i[r++])];
    return r && r == u ? t : void 0;
  }
  return S = e, S;
}
var E, rr;
function Kr() {
  if (rr) return E;
  rr = 1;
  var a = vr();
  function n(e, t, i) {
    var r = e == null ? void 0 : a(e, t);
    return r === void 0 ? i : r;
  }
  return E = n, E;
}
var K, er;
function Dr() {
  if (er) return K;
  er = 1;
  function a(n, e) {
    return n != null && e in Object(n);
  }
  return K = a, K;
}
var D, tr;
function Or() {
  if (tr) return D;
  tr = 1;
  var a = pr(), n = dr(), e = v(), t = Pr(), i = lr(), r = q();
  function u(s, f, h) {
    f = a(f, s);
    for (var _ = -1, c = f.length, o = !1; ++_ < c; ) {
      var p = r(f[_]);
      if (!(o = s != null && h(s, p)))
        break;
      s = s[p];
    }
    return o || ++_ != c ? o : (c = s == null ? 0 : s.length, !!c && i(c) && t(p, c) && (e(s) || n(s)));
  }
  return D = u, D;
}
var O, nr;
function Gr() {
  if (nr) return O;
  nr = 1;
  var a = Dr(), n = Or();
  function e(t, i) {
    return t != null && n(t, i, a);
  }
  return O = e, O;
}
var G, ar;
function Tr() {
  if (ar) return G;
  ar = 1;
  var a = or(), n = Kr(), e = Gr(), t = x(), i = cr(), r = _r(), u = q(), s = 1, f = 2;
  function h(_, c) {
    return t(_) && i(c) ? r(u(_), c) : function(o) {
      var p = n(o, _);
      return p === void 0 && p === c ? e(o, _) : a(c, p, s | f);
    };
  }
  return G = h, G;
}
var T, ir;
function wr() {
  if (ir) return T;
  ir = 1;
  function a(n) {
    return function(e) {
      return e?.[n];
    };
  }
  return T = a, T;
}
var w, ur;
function zr() {
  if (ur) return w;
  ur = 1;
  var a = vr();
  function n(e) {
    return function(t) {
      return a(t, e);
    };
  }
  return w = n, w;
}
var z, sr;
function Lr() {
  if (sr) return z;
  sr = 1;
  var a = wr(), n = zr(), e = x(), t = q();
  function i(r) {
    return e(r) ? a(t(r)) : n(r);
  }
  return z = i, z;
}
var L, fr;
function $r() {
  if (fr) return L;
  fr = 1;
  var a = Cr(), n = Tr(), e = gr(), t = v(), i = Lr();
  function r(u) {
    return typeof u == "function" ? u : u == null ? e : typeof u == "object" ? t(u) ? n(u[0], u[1]) : a(u) : i(u);
  }
  return L = r, L;
}
export {
  wr as a,
  vr as b,
  $r as r
};
